<template>
  <div class="similary-goods">
    <div class="list-wrap">
      <div class="clearfix">
        <div class="clearfix fleft">
          <button class="button is-info margin-left" @click="onChangeStatus(1)">上架选中商品</button>
          <button class="button is-danger margin-left" @click="onChangeStatus(2)" >删除选中商品</button>
          <button class="button is-info margin-left" @click="addGoods" >添加商品</button>
        </div>
        <el-pagination
                v-if="count > 0"
                @current-change="handleCurrentChange"
                :current-page="search.page"
                :page-size="search.pageSize"
                layout="total, prev, pager, next, jumper"
                :total="count"
                class="fright">
        </el-pagination>
      </div>

      <div class="tile is-parent">
        <article class="tile is-child box">
          <table class="table is-bordered">
            <thead>
            <tr>
              <th>
                <input type="checkbox" v-model="isCheckAll" @click="onCheckAll">
              </th>
              <th>商品ID</th>
              <th>原图</th>
              <th>切图</th>
              <th>商品</th>
              <th>库存</th>
              <th>类目</th>
              <th style="min-width: 60px;">价格</th>
              <th>状态</th>
              <th><span class="sort" @click="onSort">点击数<i class="fa" :class="sort.class" aria-hidden="true"></i></span></th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in list" :data-id="item.id">
              <td>
                <label class="checkbox-panel"><input type="checkbox" v-model="item.checked" @click="onCheckOne(index)"></label>
              </td>
              <td>{{item.goodsId}}</td>
              <td>
                <image-component :image="item.originImage" :width="150" :height="150" :compress="1.2"></image-component>
              </td>
              <td>
                <image-component :image="item.subImage"  :width="150" :height="150" :compress="1.2"></image-component>
              </td>
              <td>
                <a :href="item.link">
                  <p>{{item.name}}</p>
                </a>
                <image-component :image="item.image" :width="150" :height="150" :compress="1.2"></image-component>
              </td>
              <td>{{item.stock}}</td>
              <td>{{item.category}}</td>
              <td>
                <p class="price">￥{{item.price}}</p>
                <p class="origin-price">￥{{item.originPrice}}</p>
              </td>
              <td>
                <span>前端状态：</span>
                <span v-if="item.showStatus==0">未开放</span>
                <span v-if="item.showStatus==1">已开放</span><br/>
                <span>入库状态：</span>
                <span v-if="item.thirdStatus == 0">未入库</span>
                <span v-if="item.thirdStatus == 4">已入库</span>
                <span v-if="item.thirdStatus == 1 || item.thirdStatus == 2 || item.thirdStatus == 3">待审核</span>
              </td>
              <td>{{item.clickCount}}</td>
              <td>
                <button v-if="item.showStatus == 0" class="button is-primary" @click="onChangeStatus(1,index)">开放</button>
                <button class="button is-warning" v-else @click="onChangeStatus(0,index)">撤回</button>
                <button class="button is-danger" @click="onChangeStatus(2,index)">删除</button>
                <button v-if="item.thirdStatus == 0&&item.pplatform!==0" class="button is-info" @click="goRouter(item,index)">入库</button>
                <el-button v-if="item.thirdStatus == 1&&item.pplatform!==0" type="primary" :loading="true" size="small">抓取中</el-button>
                <button v-if="item.thirdStatus == 2&&item.pplatform!==0" class="button is-info"  @click="goRouter(item)" >审核</button>
                <el-button v-if="item.thirdStatus == 3&&item.pplatform!==0" type="danger"  size="small">抓取失败</el-button>
                <button v-if="item.thirdStatus == 4&&item.pplatform!==0" class="button is-info" @click="goRouter(item)">编辑</button>
              </td>
            </tr>
            </tbody>
          </table>
        </article>
      </div>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
                @current-change="handleCurrentChange"
                :current-page="search.page"
                :page-size="search.pageSize"
                layout="total, prev, pager, next, jumper"
                :total="count"
                class="fright">
        </el-pagination>
      </div>

    </div>
    <div>
      <el-dialog title="添加商品" :visible.sync="addGoodsModal.visible" :lock-scroll="false" width="80%">
        <div class="margin-left">
          <span class="font-weight">添加商品ID：</span><input type="text" v-model="addGoodsModal.goodsId">
        </div>
        <div class="margin-left margin-top">
          <span class="font-weight">选择切块</span>
          <div class="img-wrap clearfix">
            <div :class="{'img-item':checkList[index]===1?true:false}" class="imgStyle"  v-for="(item,index) in imgList" @click="checkImg(index)">
              <image-component  :image="item.subImage"  :width="100" :height="100" :compress="1.2"></image-component>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addGoodsModal.visible=false;">取消</el-button>
          <el-button type="primary" @click="doSaveAddGoods">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script type="text/babel">
    import { getTimeByDateStr } from 'UTILS/date'

    export default {
        data(){
            return {
                articleId:'',
                search:{
                    page: 1,
                    pageSize: 15,
                    sortByClickCount:null,
                },
                list:[],
                count:0,
                isCheckAll:false,
                todayData: {
                    todayGoodsCatched: 0,
                    todayGoodsOnline: 0,
                    goodsCatched: 0,
                    goodsOnline: 0,
                },
                sort:{
                    sortType:0,
                    class:{
                        'fa-sort':true,
                        'fa-sort-desc':false,
                        'fa-sort-asc':false
                    }
                },
                timer:null,
                tempFlag:true,
                tempFlagIndex:null,
                addGoodsModal:{
                    visible:false,
                    goodsId:null,
                    imageBoxes:[],
                },
                imgList:[],
                checkList:[],
            }
        },
        mounted(){
            this.articleId = this.$route.query.articleId
            this.getList();
            this.init();
        },
        methods: {
            init(){
                HttpRequest.get("/admin.php?method=fashion.getArticleBoxList",{articleId:this.articleId}).then(response => {
                    if (response.data) {
                        this.imgList = response.data.list;
                         this.imgList.forEach((item,index)=>{
                          this.checkList.push(0);
                         })
                    }
                })
            },
            checkImg(index){
                this.$set(this.checkList,index,this.checkList[index]===0?1:0)
            },
            addGoods(){
              this.checkList=[];
              this.addGoodsModal.goodsId=null;
              this.imgList.forEach((item)=>{
                  this.checkList.push(0);
              })
              this.addGoodsModal.visible=true;

            },
            doSaveAddGoods() {
                let params={
                    goodsId:this.addGoodsModal.goodsId,
                    imageBoxes:[]
                }
                for (let index in this.checkList){
                    if(this.checkList[index]===1){
                        params.imageBoxes.push({
                            imageId:this.imgList[index].imageId,
                            boxId:this.imgList[index].boxId,
                        })
                    }
                }
                if(!params.goodsId){
                    this.$message("请输入商品ID");
                    return;
                }
                if(params.imageBoxes.length===0){
                    this.$message("请选择切块")
                    return;
                }
                HttpRequest.post('/admin.php?method=fashion.doSaveImageGoods', params).then(response => {
                    if(response.data.success==1){
                        this.addGoodsModal.visible = false;
                        this.$message("保存成功")
                        setTimeout(()=>{
                            this.getList()
                        },1000)
                    }
                })
            },
            handleCurrentChange(value){
                if(this.search.page !== value){
                    this.search.page = value;
                    this.getList()
                }
            },
            timerPolling(thirdPartyGoodsId,platform,index){
                this.timer = setInterval(()=>{
                    this.getGood(thirdPartyGoodsId,platform,index);
                }, 10000);
            },
            getGood(thirdPartyGoodsId,platform,index){
                let params={
                    thirdPartyGoodsId:thirdPartyGoodsId,
                    platform:platform
                }
                HttpRequest.get('/admin.php?method=fashion.getGoodsFetchStatus', params).then(response => {
                    if(response.data.thirdStatus!==1){
                        clearInterval(this.timer);
                        this.list[index].thirdStatus=response.data.thirdStatus;
                    }
                })
            },
            onSort(){
                if(this.sort.sortType == 1){
                    this.sort.sortType = 2;
                    this.sort.class['fa-sort'] = false;
                    this.sort.class['fa-sort-desc'] = true;
                    this.sort.class['fa-sort-asc'] = false;
                }else{
                    this.sort.sortType = 1;
                    this.sort.class['fa-sort'] = false;
                    this.sort.class['fa-sort-desc'] = false;
                    this.sort.class['fa-sort-asc'] = true;
                }
                this.search.sortByClickCount = this.sort.sortType;
                this.getList(this.search);
            },
            goRouter(item,index){
                let platform = '';
                if(item.link.indexOf('taobao') > -1){
                    platform = '1';
                }else if(item.link.indexOf('tmall') > -1){
                    platform = '2';
                }else if(item.link.indexOf('mogujie') > -1){
                    platform = '3';
                }
                if(item.thirdStatus==0){
                    let params={
                        thirdPartyGoodsId:item.goodsId,
                        platform:platform,
                        isCloseWindow:0
                    }
                    HttpRequest.post('/admin.php?method=shoppingguide.doAddGoods',params).then(response => {
                        if(response.data.result){
                            this.$message("操作成功!")
                            this.list[index].thirdStatus=1;
                            clearInterval(this.timer);
                            this.timerPolling(params.thirdPartyGoodsId,params.platform,index);
                        }
                    })
                }
                if(item.thirdStatus==2){
                    window.open('/adminv/#!/thirdGoods/addGoods?hasMultiPrice=0&platform='+platform+'&thirdPartyGoodsId='+item.goodsId)
                }
                if(item.thirdStatus==4){
                    window.open('/adminv/#!/thirdGoods/addGoods?goodsId='+item.outerGoodsId)
                }
            },
            getList(){
                let params = Object.assign({}, {articleId:this.articleId}, this.search)
                HttpRequest.get('/admin.php?method=fashion.getSimilaryGoods', params).then(response => {
                    _.each(response.data.list,item => {
                        item.checked = false
                    })
                    this.todayData = response.data.todayData ? response.data.todayData : this.todayData
                    this.list = _.toArray(response.data.list);
                    this.count=response.data.count;
                    this.list.forEach((item,index) => {
                        if(item.thirdStatus==1){
                            clearInterval(this.timer);
                            this.timerPolling(item.thirdPartyGoodsId,item.platform,index);
                        }
                    })
                })
            },
            onChangeStatus(actionType,index){
                let params = {}
                if(typeof index !== "undefined"){//单个操作
                    params = {
                        actionType:actionType,
                        ids:[this.list[index].id]
                    }
                }else {//批量操作
                    let temp = []
                    this.list.forEach(item => {
                        if(item.checked){
                            temp.push(item.id)
                        }
                    })
                    if(!temp.length){
                        this.$message("当前没有可以操作的项")
                        return false
                    }
                    params = {
                        actionType:actionType,
                        ids:temp
                    }
                }
                this.operateSimilaryGoods(params)
            },
            operateSimilaryGoods(params){
                HttpRequest.post('/admin.php?method=fashion.operateSimilaryGoods',params).then(response => {
                    if(response.data.success){
                        this.$message("操作成功!")
                        this.getList()
                    }
                })
            },
            goBack(){
                this.$router.push({
                    path:'articleList',
                    query: Object.assign({}, this.$route.query, {articleId: ''})
                })
            },
            onCheckAll(){
                setTimeout(()=>{
                    if(this.isCheckAll){
                        _.each(this.list,item => {
                            item.checked = true
                        })
                    }else {
                        _.each(this.list,item => {
                            item.checked = false
                        })
                    }
                },0)
            },
            onCheckOne(index){
                setTimeout(()=>{
                    if(!this.list[index].checked){
                        this.isCheckAll = false
                        return false
                    }
                    for(let i = 0, len = this.list.length; i < len; i++){
                        if(!this.list[i].checked){
                            this.isCheckAll = false
                            return false
                        }
                    }
                    this.isCheckAll = true
                },0)
            }
        }
    }
</script>
<style lang="less" scoped>
  .similary-goods {
    .price {
      color: red;
    }
    .origin-price {
      color:#ccc;
      text-decoration: line-through;
    }

  }
  .data-wrap {
    display: flex;
    flex-wrap: wrap;
    width: 400px;
    .data-item {
      width:50%;
      margin-top: 20px;
    }
  }
  .img-wrap{
    min-height: 140px;
    max-height: 230px;
    overflow: auto;
    .imgStyle{
      border:5px solid #fff;
      margin-right: 10px;
      margin-bottom: 10px;
      float: left;
    }
    .img-item{
      border:5px solid #7a3ce9;
    }
  }
  .font-weight{
    font-weight: bold;
  }
</style>
